import { useState } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetCustomerProducts } from 'core/Store/customerProducts/actions';
import { Product } from 'core/types/product';

export default function useCustomerProductsImport(customerId: number) {
  const showErrorNotification = useErrorNotifications();
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useSubstate(() => null);

  const importProducts = (file: File) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('products', file);

    return client()
      .post<Array<Product & { pivot: { price: number } }>>(
        `customers/${customerId}/products/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      .then(response => response.data)
      .then(products => dispatch(new SetCustomerProducts(customerId, products)))
      .catch(error => {
        showErrorNotification(error);
        throw error;
      })
      .finally(() => setLoading(false));
  };

  return { importProducts, loading };
}
